module.exports = __webpack_public_path__ + "img/poster_01.9fc4002e.jpg";